import React from 'react';
import { Link } from 'react-router-dom';
import AdminJobsView from '../../components/AdminJobsView';

const AdminJobsPage = () => {
  return (
    <div className="space-y-8">
      <div className="card">
        <div className="card-header">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-foreground">Job Management</h1>
              <p className="text-sm text-muted-foreground mt-1">Monitor and manage all background jobs</p>
            </div>
            <Link to="/admin" className="btn btn-secondary">
              ← Back to Admin
            </Link>
          </div>
        </div>
        
        <div className="card-body">
          <AdminJobsView />
        </div>
      </div>
    </div>
  );
};

export default AdminJobsPage;